import React from 'react'

import config from '../config.js'

class UserArea extends React.Component {
  propTypes: {
    userNameDisplay: React.PropTypes.string,
    logout: React.PropTypes.func
  }

  logoutHandler = e => {
    e.preventDefault()
    this.props.logout()
  }

  render(userNameDisplay) {
    return (
      <div className="user-area">
        <img
          className="user-area__avatar"
          src={
            this.props.userAvatar == null
              ? config.baseUrl + '/assets/img/generic-avatar-medium.png'
              : this.props.userAvatar + '=s96-c'
          }
          alt={''}
        />
        <span className="user-area__name">{this.props.userNameDisplay}</span>
        <br />
        <a
          className="user-area__link--logout link-function"
          onClick={e => {
            this.logoutHandler(e)
          }}
        >
          Log Out
        </a>
      </div>
    )
  }
}

export default UserArea



// WEBPACK FOOTER //
// ./src/Components/UserArea.js